import { isEmpty } from 'lodash';
import React, { useState } from 'react';
import { Modal } from "react-bootstrap";
// import { useSelector } from 'react-redux';

const ModifyPassword = ({
    pwdModifyModal,
    getLangTranslation,
    setPwdModifyModal,
    setPwd
}) => {
    const [current, setCurrent] = useState({ value: '', error: '' })
    const [newPwd, setNewPwd] = useState({ value: '', error: '' })
    const [confirmNewPwd, setConfirmNewPwd] = useState({ value: '', error: '' })

    const [displayType, setDisplayType] = useState({
        current: 'password', newPwd: 'password', confirmNewPwd: 'password'
    })

    function handlePwdChagne(e) {
        const { name, value } = e.target;

        if (value.length > 16) {
            return;
        }

        if (name === 'CURR_PWD') {
            setCurrent({
                value,
                error: ''
            })
        } else if (name === 'NEW_PWD') {
            setNewPwd({
                value,
                error: ''
            })
        } else if (name === 'CNFRM_NEW_PWD') {
            setConfirmNewPwd({
                value,
                error: ''
            })
        }
    }

    function handleSave() {
        let flag = true;
        if (isEmpty(current?.value)) {
            setCurrent({
                ...current,
                error: 'Current password is mandatory'
            })
            flag = false;
        }

        if (isEmpty(newPwd?.value)) {
            setNewPwd({
                ...newPwd,
                error: 'New password is mandatory'
            })
            flag = false;
        }

        if (isEmpty(confirmNewPwd?.value)) {
            setConfirmNewPwd({
                ...confirmNewPwd,
                error: 'Confirm password is mandatory'
            })
            flag = false;
        }

        if (flag) {
            if (newPwd?.value?.length < 8 || newPwd?.value?.length > 16) {
                setNewPwd({
                    ...newPwd,
                    error: getLangTranslation('PWD_8_TO_16_CHAR_LONG', 'Password must be 8 to 16 characters long')
                })
                flag = false;
            } else if (newPwd?.value !== confirmNewPwd?.value) {
                setConfirmNewPwd({
                    ...confirmNewPwd,
                    error: getLangTranslation('NEW_PASSWORD_PASSWORD_NOT_MATCH_ERROR', 'New password and confirm password not match.')
                })
                flag = false;
            }
        }

        if (!flag) {
            return;
        }

        const pwd = {
            current: { value: current?.value, error: '' },
            newPwd: { value: newPwd?.value, error: '' },
            confirmNewPwd: { value: confirmNewPwd?.value, error: '' }
        }

        setPwd({ ...pwd });
        setPwdModifyModal(false);
    }

    return (
        <Modal
            show={pwdModifyModal}
            size="sm"
            className="custom-modal blur-bg"
            centered
        >
            <Modal.Header>
                <div className="border-0 pb-0 d-flex justify-content-between w-100">
                    {/* <h6 className="modal-title text-blue-900">Change Password</h6> */}
                    <button
                        type="button"
                        className="btn-close"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                        onClick={() => {
                            setPwd({
                                current: { value: '', error: '' },
                                newPwd: { value: '', error: '' },
                                confirmNewPwd: { value: '', error: '' }
                            })
                            setPwdModifyModal(false);
                        }}
                    ></button>
                </div>
            </Modal.Header>
            <Modal.Body className="px-4">
                <div className="">
                    <form>
                        <div className="mb-3">
                            <label
                                htmlFor="CURR_PWD"
                                className="form-label"
                            >
                                {getLangTranslation('CHANGE_PWD_CURRENT_PASSWORD', 'Current Password')}
                            </label>
                            <div className="input-group ">
                                <input
                                    type={displayType?.current}
                                    className="form-control border-end-0"
                                    id="CURR_PWD"
                                    name="CURR_PWD"
                                    placeholder={getLangTranslation('CHANGE_PWD_CURRENT_PASSWORD', 'Current Password')}
                                    value={current?.value}
                                    onChange={handlePwdChagne}
                                    autoComplete='current-password'
                                />
                                <span
                                    className="input-group-text border-start-0 pt-cursor"
                                    id="basic-addon3"
                                    onClick={() => {
                                        setDisplayType({
                                            ...displayType,
                                            current: displayType?.current === 'password' ? 'text' : 'password'
                                        })
                                    }}
                                >
                                    <i
                                        className={`fa ${displayType?.current === 'password' ? 'fa-eye-slash' : 'fa-eye'}`}
                                        id="togglePassword"></i>
                                </span>
                            </div>
                            {
                                current?.error && (
                                    <div className='text-danger fs-7'>
                                        {current?.error}
                                    </div>
                                )
                            }
                        </div>
                        <div className="mb-3">
                            <label
                                htmlFor="NEW_PWD"
                                className="form-label"
                            >
                                {getLangTranslation('NEW_PASSWORD_TITLE', 'New password')}
                            </label>
                            <div className="input-group ">
                                <input
                                    type={displayType?.newPwd}
                                    className="form-control border-end-0"
                                    id="NEW_PWD"
                                    name="NEW_PWD"
                                    placeholder={getLangTranslation('NEW_PASSWORD_TITLE', 'New password')}
                                    value={newPwd?.value}
                                    onChange={handlePwdChagne}
                                    autoComplete='new-password'
                                />
                                <span
                                    className="input-group-text border-start-0 pt-cursor"
                                    id="basic-addon3"
                                    onClick={() => {
                                        setDisplayType({
                                            ...displayType,
                                            newPwd: displayType?.newPwd === 'password' ? 'text' : 'password'
                                        })
                                    }}
                                >
                                    <i
                                        className={`fa ${displayType?.newPwd === 'password' ? 'fa-eye-slash' : 'fa-eye'}`}
                                        id="togglePassword"></i>
                                </span>
                            </div>
                            {
                                newPwd?.error && (
                                    <div className='text-danger fs-7'>
                                        {newPwd?.error}
                                    </div>
                                )
                            }
                        </div>
                        <div className="mb-3">
                            <label
                                htmlFor="CNFRM_NEW_PWD"
                                className="form-label"
                            >
                                {getLangTranslation('NEW_PASSWORD_CONFIRM_ET_TEXT', 'Confirm password')}
                            </label>
                            <div className="input-group ">
                                <input
                                    type={displayType?.confirmNewPwd}
                                    className="form-control border-end-0"
                                    id="CNFRM_NEW_PWD"
                                    name="CNFRM_NEW_PWD"
                                    placeholder={getLangTranslation('NEW_PASSWORD_CONFIRM_ET_TEXT', 'Confirm password')}
                                    value={confirmNewPwd?.value}
                                    onChange={handlePwdChagne}
                                    autoComplete='new-password'
                                />
                                <span
                                    className="input-group-text border-start-0 pt-cursor"
                                    id="basic-addon3"
                                    onClick={() => {
                                        setDisplayType({
                                            ...displayType,
                                            confirmNewPwd: displayType?.confirmNewPwd === 'password' ? 'text' : 'password'
                                        })
                                    }}
                                >
                                    <i
                                        className={`fa ${displayType?.confirmNewPwd === 'password' ? 'fa-eye-slash' : 'fa-eye'}`}
                                        id="togglePassword"></i>
                                </span>
                            </div>
                            {
                                confirmNewPwd?.error && (
                                    <div className='text-danger fs-7'>
                                        {confirmNewPwd?.error}
                                    </div>
                                )
                            }
                        </div>
                    </form>
                </div>
                <button
                    className="btn btn-primary w-100"
                    type="button"
                    onClick={() => handleSave()}
                >
                    <span className="btn-upper-case">
                        {getLangTranslation('SAVE', 'Save')}
                    </span>
                </button>
            </Modal.Body>
        </Modal>
    )
}

export default ModifyPassword;